import React from "react";
import ContactCard from "./ContactCard";
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { MdOutlineAlternateEmail } from "react-icons/md";

const Contact = () => {
    return (
        <div className="w-[90%] h-[100vh] flex flex-col lg:flex-row gap-4 p-8 items-center justify-center">
            <div className="flex w-[80%] h-[100%] flex flex-col items-center justify-center md:items-start lg:ml-[10%] lg:mt-4">
                <div className="text-[70px] text-customGreen md:text-[100px] font-bold text-white ml-8">
                    Contact<span className="text-customGreen">.</span>
                </div>
                <div className="flex flex-row items-center" data-aos="fade-up"
                    data-aos-duration="960" data-aos-delay="150">
                    <div className="h-1 w-16 bg-customGreen"></div>
                    <span className="text-[20px] md:text-[25px] ml-4 text-white">Get in touch with me</span>
                </div>
            </div>
            <div className="flex w-[100%] md:w-[80%] h-[80%] items-center justify-around md:mt-[40px] flex flex-col">
                <ContactCard Icon={FaGithub} text="@vpescete" link="https://github.com/vpescete" data-aos="fade-right"/>
                <ContactCard Icon={MdOutlineAlternateEmail} text="valeriopescetellinl@gmail.com" link="valeriopescetellinl@gmail.com" data-aos="fade-left"/>
                <ContactCard Icon={FaLinkedin} text="Valerio Pescetelli" link="https://www.linkedin.com/in/valeriopescetelli/" data-aos="fade-right"/>
            </div>
        </div>
    );
};

export default Contact;